import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Renderer2, EventEmitter, ElementRef, OnDestroy } from '@angular/core';
import { Repository } from '../../../services/repository';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';

const swal = require('sweetalert');

@Component({
  selector: 'app-daotao-solienlacedit',
  templateUrl: './solienlacedit.component.html',
  styleUrls: ['./solienlacedit.component.scss'],
  providers: [
    Repository,
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    TableService,
    FileManagerService
  ],
  encapsulation: ViewEncapsulation.None
})
export class SoLienLacEditComponent implements OnInit, OnDestroy {

  private hostUrl: string = '/';
  public dropElement: HTMLElement;
  @Output() save = new EventEmitter<any>();
  @ViewChild('noiBaiHocEditor') noiBaiHocEditor: RichTextEditorComponent;
  @ViewChild('attachmentUploader') attachmentUploader: UploaderComponent;

  // Form for evaluation data
  evaluationForm: FormGroup;

  // Current evaluation data
  currentData: any = {};

  // Options for attendance dropdown
  attendanceOptions = [
    { id: 1, name: 'Đi học' },
    { id: 2, name: 'Nghỉ học' },
    { id: 3 , name: 'Khác' }
  ];

  // Lists for comboboxes
  todayPerformanceOptions: any[] = [];
  classPerformanceOptions: any[] = [];
  needImprovementOptions: any[] = [];
  homeWorkOptions: any[] = [];

  // Editor configurations
  public myCodeMirror: any;
  public textArea: HTMLElement;
  public maxLength = 20000;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileUpLoadManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
      uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
      downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
    }
  };

  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };

  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }
  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    } else {
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);

    }
  }

  public path: object = {
    saveUrl: '/api/daotao/uploadfile',
    removeUrl: '/api/daotao/deletefile'
  };

  public uploadFields: object = { name: 'UploadFiles' };
  public multiple: boolean = true;
  public autoUpload: boolean = true;
  uploadedFiles: any[] = [];
  public dynamicHeight: number;
  constructor(
    private renderer: Renderer2,
    private fb: FormBuilder,
    public repo: Repository,
    private elementRef: ElementRef
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    

    this.dropElement = document.querySelector('.control-fluid') as HTMLElement;
  }

  // Add ngAfterViewInit to ensure the element is available
  ngAfterViewInit(): void {
    // Alternative approach if the control-fluid class isn't found
    if (!this.dropElement) {
      this.dropElement = this.elementRef.nativeElement.querySelector('.file-upload-area') as HTMLElement;
    }
    setTimeout(() => {
      this.setDynamicHeight();
      this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      this.rteObj.toolbarModule.refreshToolbarOverflow();
    }, 500);
  }
  donViId: any;
  private setDynamicHeight(): void {
    const height = window.innerHeight - 120; // Adjust for header/footer
    this.dynamicHeight = height;
    //this.renderer.setStyle(this.elementRef.nativeElement.querySelector('as-split'), 'height', this.dynamicHeight);
  }
  // Create the form with validation
  createForm(): void {
    this.evaluationForm = this.fb.group({
      Id: [null],
      HocVienId: [null, Validators.required],
      NgayHoc: [new Date(), Validators.required],
      DiemDanh: [1, Validators.required],
      NoiDungBaiHoc: [''],
      TodayPerformance: [null],
      ClassPerformance: [[]],
      BieuHienTrongLopKhac: [''],
      Diem:0,
      NeedImprovement: [[]],
      CaiThienKhac: [''],
      HomeWork: [[]],
      BaiTapKhac: [''],
      LinkBaiTap: [''],
      LinkVideo: [''],
      NhanXetChung: ['', Validators.required],
      TrangThai: 0,
      LopHocId: 0,
      AttachFiles: [[]]
    });
  }

  // Load dropdown data from API
  loadDropdownData(donViId:any): void {
    // Load today performance options (Loai = 1)
    this.repo.postRequest('api/daotao/getdmchitieu', { Loai: 1, Language: 'vi', LoaiEduno: 0, DonViId: donViId })
      .subscribe(res => {
        if (res && res.length > 0) {
          this.todayPerformanceOptions = res;
        }
      });

    // Load class performance options (Loai = 2)
    this.repo.postRequest('api/daotao/getdmchitieu', { Loai: 2, Language: 'vi', LoaiEduno: 0, DonViId: donViId })
      .subscribe(res => {
        if (res && res.length > 0) {
          this.classPerformanceOptions = res;
        }
      });

    // Load need improvement options (Loai = 3)
    this.repo.postRequest('api/daotao/getdmchitieu', { Loai: 3, Language: 'vi', LoaiEduno: 0, DonViId: donViId })
      .subscribe(res => {
        if (res && res.length > 0) {
          this.needImprovementOptions = res;
          
        }
      });
    this.repo.postRequest('api/daotao/getdmchitieu', { Loai: 4, Language: 'vi', LoaiEduno: 0, DonViId: donViId })
      .subscribe(res => {
        if (res && res.length > 0) {
         
          this.homeWorkOptions = res; 
        }
      });
  }

  // Load data into the form
  loadData(data: any): void {
    this.currentData = data || {};
    this.loadDropdownData(data.DonViId);
    // Reset form
    this.evaluationForm.reset();

    // Set form values
    if (data) {
      // Parse string arrays if necessary
      let classPerformance = data.classPerformance;
      if (typeof classPerformance === 'string') {
        console.log("vao1");
        try {
          if (classPerformance && classPerformance.length > 0) {
            console.log("vao11");
            if (classPerformance.includes(',')) {
              console.log("vao111");
              // If it contains commas, split by comma
              classPerformance = classPerformance.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
            } else {
              console.log("vao112");
              // If it doesn't contain commas but has content, treat as a single value
              const parsedValue = parseInt(classPerformance.trim());
              classPerformance = !isNaN(parsedValue) ? [parsedValue] : [];
            }
          } else {

            classPerformance = [];
          }
        } catch (e) {
          console.error('Error parsing ClassPerformance:', e);
          classPerformance = [];
        }
      }


      let needImprovement = data.needImprovement;
      if (typeof needImprovement === 'string') {
        try {
          if (needImprovement && needImprovement.length > 0) {
            if (needImprovement.includes(',')) {
              // If it contains commas, split by comma
              needImprovement = needImprovement.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
            } else {
              // If it doesn't contain commas but has content, treat as a single value
              const parsedValue = parseInt(needImprovement.trim());
              needImprovement = !isNaN(parsedValue) ? [parsedValue] : [];
            }
          } else {
            needImprovement = [];
          }
        } catch (e) {
          console.error('Error parsing NeedImprovement:', e);
          needImprovement = [];
        }
      }

      let homeWork = data.homeWork;
      if (typeof homeWork === 'string') {
        try {
          if (homeWork && homeWork.length > 0) {
            if (homeWork.includes(',')) {
              // If it contains commas, split by comma
              homeWork = homeWork.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
            } else {
              // If it doesn't contain commas but has content, treat as a single value
              const parsedValue = parseInt(homeWork.trim());
              homeWork = !isNaN(parsedValue) ? [parsedValue] : [];
            }
          } else {
            homeWork = [];
          }
        } catch (e) {
          console.error('Error parsing HomeWork:', e);
          homeWork = [];
        }
      }

      console.log(data);
      


      // Set values in form
      this.evaluationForm.patchValue({
        Id: data.Id,
        HocVienId: data.HocVienId,
        LopHocId:0,
        NgayHoc: data.NgayHoc ? new Date(data.NgayHoc) : new Date(),
        DiemDanh: data.DiemDanh || 1,
        NoiDungBaiHoc: data.NoiDung || '',
        TodayPerformance: data.todayPerformance ? parseInt(data.todayPerformance.toString(), 10) : null,
        ClassPerformance: classPerformance,
        BieuHienTrongLopKhac: data.BieuHienTrongLopKhac || '',
        NeedImprovement: needImprovement,
        Diem: data.Diem,
        CaiThienKhac: data.CaiThienKhac || '',
        HomeWork: homeWork,
        BaiTapKhac: data.BaiTapKhac || '',
        LinkBaiTap: data.LinkBaiTap || '',
        LinkVideo: data.LinkVideo || '',
        NhanXetChung: data.NhanXetChung || '',
        TrangThai:0,
        AttachFiles: data.AttachFiles || []
      });

      // Update existing files
      this.uploadedFiles = data.AttachFiles || [];

      console.log(this.evaluationForm);
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);
    }
    else {
      console.log('Vao duoi');
      this.evaluationForm.patchValue({
        TrangThai: 0,
        LopHocId: 0,
        AttachFiles: []
      });
    }
  }

  // Handle file upload success
  onUploadSuccess(args: any): void {
    console.log(args);
    

    if (args.operation === 'upload') {

      var path1 = '';
      var customHeader = args.response.headers.split("\r\n"); // To split the response
      var length = customHeader.length;
      for (var i = 0; i <= length; i++) {
        if (customHeader[i].indexOf(":") > 0) {
          var str = customHeader[i].split(":");
          if (str[0] == "path") {
            path1 = str[1].trim(); break;
          }
        }
      }

      const files = args.file?.files || [];
      const newFiles  = {
        name: args.file.name,
        size: args.file.size,
        type: args.file.type,
        path: path1// args.response.statusText // Adjust based on your server response
      };
      console.log(newFiles);
      // Update form value
      const currentFiles = this.evaluationForm.get('AttachFiles').value || [];
      this.evaluationForm.patchValue({
        AttachFiles: [...currentFiles, newFiles]
      });

      this.uploadedFiles = [...this.uploadedFiles, newFiles];

      console.log(this.uploadedFiles);
    }
  }
  public onFileUploading(args: any): void {
    // Add custom form data parameters
    args.customFormData = [
      { 'donViId': this.currentData.DonViId },
      { 'hocVienId': this.evaluationForm.get('HocVienId').value },
      { 'folder': 'SoLienLac' },
    
    ];
  }
  // Handle file remove
  onFileRemoved(args: any): void {
    const fileName = args.filesData?.[0]?.name;
    if (fileName) {
      this.uploadedFiles = this.uploadedFiles.filter(file => file.name !== fileName);
      this.evaluationForm.patchValue({
        AttachFiles: this.uploadedFiles
      });
    }
  }

  // Save the form data
  saveData(trangthai:any): void {
    if (this.evaluationForm.invalid) {
      // Mark all fields as touched to show validation errors
      Object.keys(this.evaluationForm.controls).forEach(key => {
        this.evaluationForm.get(key).markAsTouched();
      });

      swal({
        title: this.ngonngu('Error'),
        text: this.ngonngu('Please complete the required fields'),
        icon: 'error'
      });

      return;
    }

    // Prepare data for saving
    const formData = this.evaluationForm.value;

    formData.TrangThai = trangthai;

    // Convert array to comma-separated string for backend
    if (Array.isArray(formData.ClassPerformance)) {
      formData.ClassPerformance = formData.ClassPerformance.join(',');
    }

    if (Array.isArray(formData.NeedImprovement)) {
      formData.NeedImprovement = formData.NeedImprovement.join(',');
    }

    if (Array.isArray(formData.HomeWork)) {
      formData.HomeWork = formData.HomeWork.join(',');
    }

    // Convert date to ISO string
    if (formData.NgayHoc instanceof Date) {
      formData.NgayHoc = this.formatDate(formData.NgayHoc);
    }
   
    console.log(formData);
    // Emit the save event with the form data
    this.save.emit(formData);
  }

  // Format date to DD/MM/YYYY
  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Helper method to display label text in the current language
  ngonngu(text: string): string {
    return this.repo.NgonNgu(text);
  }

  // Safely destroy components
  ngOnDestroy(): void {
    try {
      // Destroy RichTextEditor safely
      if (this.rteObj && !this.rteObj.isDestroyed) {
        // Remove ColorPicker and other controls before destroying
        if (this.rteObj.toolbarModule) {
          this.rteObj.toolbarModule.destroy();
        }

        // Destroy the main RTE instance
        this.rteObj.destroy();
      }

      // Destroy other RTE editor if exists
      if (this.noiBaiHocEditor && !this.noiBaiHocEditor.isDestroyed) {
        if (this.noiBaiHocEditor.toolbarModule) {
          this.noiBaiHocEditor.toolbarModule.destroy();
        }
        this.noiBaiHocEditor.destroy();
      }

      // Destroy uploader if exists
      if (this.attachmentUploader && !this.attachmentUploader.isDestroyed) {
        this.attachmentUploader.destroy();
      }

      // Clean up CodeMirror
      if (this.myCodeMirror) {
        this.myCodeMirror = null;
      }

    } catch (error) {
      console.warn('Error during component cleanup:', error);
    }
  }

  // Cancel and close the modal
  cancel(): void {
    // Clean up any resources if needed
    //this.evaluationForm.reset();
    this.save.emit(null);
  }
}
